require('./cardChargeStep1.scss');

//@ Vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

//@ Commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @utilities
const { formatCurrency, formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getCardAvailableBalance } = require('utilities/cardsHelper');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

//@ Actions
const cardChargeActions = require('actions/cardCharge');

//@ Components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { AmountInput } = require('commonsComponents/amountInput');
const { LoadingDots } = require('commonsComponents/loadingDots');
const CardChargePeriodicTransfer = require('./../cardChargePeriodicTransfer/cardChargePeriodicTransfer')
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @ Constants
const {
    CARD_MIN_BALANCE,
    CARD_CHARGE_OPERATION_CHARGE,
    CARD_CHARGE_OPERATION_DISCHARGE,
    ECARD_MAX_BALANCE,
    OPENYOUNG_MAX_BALANCE,
    MONEY_REQUEST_VIEW,
    SAVINGS_REQUEST_VIEW
} = require('constants/index');
const language = getLanguage();

class CardChargeStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.buildAccountDropdown = this.buildAccountDropdown.bind(this);
        this.buildEmptyCardDischargeError = this.buildEmptyCardDischargeError.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleWidthdrawTotalAmount = this.handleWidthdrawTotalAmount.bind(this);
        this.buildWithdrawTotalAmountCheckbox = this.buildWithdrawTotalAmountCheckbox.bind(this);
    }

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.buildAccountsOptions(), immAccounts.get('byId'));

        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    getPrepaidBalance() {
        const { isLoading, immCard } = this.props;
        const amount = getCardAvailableBalance(immCard);
        const plainAmountObject = getPlainAmountObject(amount);

        if (isLoading) {
            return (
                <span className="card-charge-step-one__balance">
                    <LoadingDots inline color="dark" size="small" />
                </span>
            );
        }

        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                className="card-charge-step-one__balance"
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
    }

    buildAccountDropdown() {
        const { immCardCharge, isInactiveAccountsEnabled, accountId, view, immAccounts } = this.props;

        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        const accountDirty = immCardChargeStep1.get('accountDirty');
        const operationType = immCardChargeStep1.get('operationType');
        const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
        const isDisabled = immCardChargeStep1.get('isEdit');

        let showError = false;
        let accountError;
        if (accountDirty && !immCardChargeStep1.get('accountChosen')) {
            showError = true;
            accountError = formatText('cardCharge-accountError');
        } else if (accountDirty && operationType === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
            showError = false;
        } else if (accountDirty && !immCardChargeStep1.get('accountHasBalance')) {
            showError = true;
            accountError = formatText('cardCharge-accountHasNotBalanceError');
        }

        const accountSelectionOptions = this.buildAccountsOptions();
        const accountsDropdownLabel = (view === SAVINGS_REQUEST_VIEW) ? 'moneySavingsRequest-accountsDropdownLabel' : 'cardCharge-accounts';
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <div className="card-charge-step-one__accounts-selector">
                <DropdownAccounts
                    label={accountsDropdownLabel}
                    name="form-field-account-id"
                    className="dropdown-accounts"
                    onAccountChange={this.handleAccountChange}
                    currentAccountId={accountId}
                    accountsIndexes={accountSelectionOptions}
                    immAccounts={immAccounts.get('byId')}
                    error={showError}
                    disabled={isDisabled}
                    errorMsg={accountError}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsgContent}
                />
            </div>
        );
    }

    buildAccountsOptions() {
        const {
            immAccounts,
            view,
            oyAccounts
        } = this.props;
        let accounts = immAccounts.get('byOrder');
        if(view === MONEY_REQUEST_VIEW) {
            accounts = accounts.filter(accountId => {
                const immAccount = immAccounts.getIn(['byId', accountId]);
                if(immAccount.getIn(['balances', 'availableBalance', 'amount']) > 0) {
                    return accountId;
                }
            });
        } else if(view === SAVINGS_REQUEST_VIEW) {
            accounts = oyAccounts;
        }
        return accounts.toJS();
    }

    buildEmptyCardDischargeError() {
        const {
            immCardCharge,
            operationType,
            view
        } = this.props;
        const immFirstStep = immCardCharge.getIn(['steps', 0]);

        if (
            !immFirstStep.get('operationDirty') ||
            operationType === CARD_CHARGE_OPERATION_CHARGE ||
            immFirstStep.get('operationValid') ||
            view === SAVINGS_REQUEST_VIEW
        ) {
            return;
        }

        const cardChargeOperationErrorMessage = formatText('cardCharge-operationError');
        return (
            <div className="ok-select__error-msg">
                {cardChargeOperationErrorMessage}
            </div>
        );
    }

    handleAccountChange(account) {
        const { setAccount } = this.props;
        setAccount(account);
    }

    handleWidthdrawTotalAmount(evt) {
        const { immCard, handleAmountChange, withdrawTotalAmount } = this.props;
        const amount = getCardAvailableBalance(immCard);
        withdrawTotalAmount(evt.target.checked);
        handleAmountChange(amount.amount);
    }

    buildWithdrawTotalAmountCheckbox(isChargeOperation) {
        let content;
        const {
            immCard,
            immCardCharge,
            withdrawTotalAmount,
            view
        } = this.props;

        const amount = getCardAvailableBalance(immCard);

        if(isChargeOperation || view === SAVINGS_REQUEST_VIEW) {
            withdrawTotalAmount(false);
        } else {
            const label = <FormattedText value="cardCharge-dischargeTotal" />;
            content = (
                <span className="card-charge-step-one__withdraw-total">
                    <OKCheckbox
                        idName="dischargeTotal"
                        label={label}
                        onChange={this.handleWidthdrawTotalAmount}
                        disabled={!amount.amount}
                        value={immCardCharge.getIn(['steps', 0, 'withdrawTotal'])}
                    />
                </span>
            );
        }

        return content;
    }

    getMaxAmount(currency) {
        const {
            immCard,
            view
        } = this.props;
        let maxAmount;
        const cardAmount = getPlainAmountObject(getCardAvailableBalance(immCard)).amount;
        const maxBalanceforCard = immCard.get('isOpenYoung') ? OPENYOUNG_MAX_BALANCE : ECARD_MAX_BALANCE;
        if (!immCard.get('isOpenYoung')){
            maxAmount = `${formatAmount(ECARD_MAX_BALANCE)} ${currency}`;
        } else {
            switch(view) {
                case MONEY_REQUEST_VIEW: {
                    const maxCardAmountforMoneyRequest = maxBalanceforCard - cardAmount;
                    maxAmount = `${formatAmount(maxCardAmountforMoneyRequest)} ${currency}`;
                    break;
                }
                case SAVINGS_REQUEST_VIEW: {
                    const cardAmount = getPlainAmountObject(getCardAvailableBalance(immCard)).amount;
                    maxAmount = `${formatAmount(cardAmount)} ${currency}`;
                    break;
                }
                default: {
                    maxAmount = `${formatAmount(OPENYOUNG_MAX_BALANCE)} ${currency}`;
                    break;
                }
            }
        }
        return maxAmount;
    }

    render() {
        const {
            operationType,
            immCard,
            immCardCharge,
            handleAmountChange,
            handleOperationTypeChange,
            isPeriodicTransfer,
            handlePeriodicityType,
            handlePeriodicityRange,
            handlePeriodicityDate,
            handlePeriodicityCount,
            handlePeriodicityEnabled,
            handlePeriodicityConcept,
            setDate,
            setTodayDate,
            view
        } = this.props;
        let amountError,
        prepaidBalance,
        operationTypes,
        title;
        const radio1Label = formatText('cardCharge-charge');
        const radio2Label = formatText('cardCharge-discharge');
        const immFirstStep = immCardCharge.getIn(['steps', 0]);
        const isToday = immFirstStep.get('isToday');
        const amountDirty = immFirstStep.get('amountDirty');
        const amount = immFirstStep.get('amount');
        const accountChosen = immFirstStep.get('accountChosen');
        const operationValid = immFirstStep.get('operationValid');
        const accountHasBalance = immFirstStep.get('accountHasBalance');
        const amountMiniumReached = immFirstStep.get('amountMiniumReached');
        const amountMaximumReached = immFirstStep.get('amountMaximumReached');
        const amountAvailableinAccount = immFirstStep.get('amountAvailableinAccount');
        const periodicityEnabled = immFirstStep.get('periodicityEnabled');
        const isEditFlow = immFirstStep.get('isEdit');
        let showAmountError;

        const currency = formatCurrency(
            immCard.getIn(['availableBalance','currency'])
        );

        let maxLimit;
        let maxAmount;

        if (immCard.get('isOpenYoung')) {
            maxLimit = OPENYOUNG_MAX_BALANCE;
            maxAmount = `${formatAmount(OPENYOUNG_MAX_BALANCE)} ${currency}`;
        } else {
            maxLimit = ECARD_MAX_BALANCE;
            maxAmount = `${formatAmount(ECARD_MAX_BALANCE)} ${currency}`;
        }

        if((isToday && !periodicityEnabled) || operationType === CARD_CHARGE_OPERATION_DISCHARGE) {
            showAmountError =
            amountDirty &&
            operationValid &&
            (!amountMiniumReached ||
                !amountMaximumReached ||
                (accountChosen &&
                    accountHasBalance &&
                    (!amountAvailableinAccount || !amountMaximumReached)));
        } else {
            showAmountError =
            amountDirty &&
            operationValid &&
            (!amountMiniumReached ||
                !amountMaximumReached ||
                (accountChosen &&
                     (!amountMaximumReached && amount > maxLimit)));
        }

        const cardAmount = getPlainAmountObject(getCardAvailableBalance(immCard)).amount;
        let maxBalanceforCard = immCard.get('isOpenYoung') ? OPENYOUNG_MAX_BALANCE : ECARD_MAX_BALANCE;
        title = (view === SAVINGS_REQUEST_VIEW) ? 'moneySavingsRequest-acceptSubtitle' : 'moneyRequestView-acceptContentTitle';
        const maxCardAmountforMoneyRequest = (view === SAVINGS_REQUEST_VIEW) ? cardAmount : maxBalanceforCard - cardAmount;

        if (!amountMiniumReached) {
            if (operationType === CARD_CHARGE_OPERATION_CHARGE || operationType === CARD_CHARGE_OPERATION_DISCHARGE) {
                amountError = formatText('cardCharge-chargeMinAmountError');
            }
        } else {
            if(isToday && !periodicityEnabled) {
                if (!amountMaximumReached) {
                    maxAmount = this.getMaxAmount(currency);
                    if (operationType === CARD_CHARGE_OPERATION_CHARGE) {
                        amountError = formatText('cardCharge-chargeMaxAmountError', [maxAmount]);
                    } else {
                        amountError = formatText('cardCharge-dischargeMaxAmountError');
                    }

                } else if (!amountAvailableinAccount) {
                    if (operationType === CARD_CHARGE_OPERATION_CHARGE) {
                        amountError = formatText('cardCharge-chargeAmountError');
                    }
                }
            } else if(operationType === CARD_CHARGE_OPERATION_CHARGE){
                if(immCard.get('isOpenYoung') && amount > OPENYOUNG_MAX_BALANCE ) {
                    amountError = formatText('cardCharge-chargeMaxAmountError', [maxAmount]);
                } else if ( amount > ECARD_MAX_BALANCE ) {
                    amountError = formatText('cardCharge-chargeMaxAmountError', [maxAmount]);
                }
            }
        }

        const isChargeOperation = operationType === CARD_CHARGE_OPERATION_CHARGE;
        let maxCardAmount;
        if(isChargeOperation) {
            if(!periodicityEnabled) {
                maxCardAmount = formatCurrency(maxCardAmountforMoneyRequest);
            } else {
                maxCardAmount = maxBalanceforCard;
            }
        } else {
            maxCardAmount = cardAmount;
        }
        let minCardAmount = formatCurrency(CARD_MIN_BALANCE);
        let instructionsMessage = '';
        if(maxCardAmount) {
            instructionsMessage = formatText('cardCharge-minMaxMessage', [
                formatAmount(minCardAmount),
                formatAmount(maxCardAmount)
            ]);
        }

        const accountSelection = this.buildAccountDropdown();
        const cardDischargeOperationError = this.buildEmptyCardDischargeError();
        const withdrawTotalAmountComponent = this.buildWithdrawTotalAmountCheckbox(isChargeOperation);
        const disableInputField = immCardCharge.getIn(['steps', 0, 'withdrawTotal']) && !isChargeOperation;

        if(view !== MONEY_REQUEST_VIEW && view !== SAVINGS_REQUEST_VIEW) {
            title = 'cardCharge-chargeData';
            prepaidBalance = (
                <div>
                    <FormattedText
                        className="card-charge-step-one__label"
                        value="cardCharge-balance"
                    />
                    {this.getPrepaidBalance()}
                </div>
            )
            if(!isEditFlow) {
                operationTypes = (
                    <div>
                        <FormattedText
                            className="card-charge-step-one__label"
                            value="cardCharge-operationType"
                        />
                        <RadioButtonGroup
                            name="operationType"
                            idPrefix="operationTypeRadio"
                            selectedValue={operationType}
                            onChange={handleOperationTypeChange}
                            className="card-charge-step-one__radio-group"
                        >
                            <RadioButton
                                label={radio1Label}
                                value={CARD_CHARGE_OPERATION_CHARGE}
                                className="card-charge-step-one__radio"
                            />
                            <RadioButton
                                label={radio2Label}
                                value={CARD_CHARGE_OPERATION_DISCHARGE}
                                className="card-charge-step-one__radio"
                            />
                        </RadioButtonGroup>
                    </div>
                )
            }
        }

        let periodicTransferFields;
        if(isPeriodicTransfer && operationType === CARD_CHARGE_OPERATION_CHARGE){
            periodicTransferFields = (
                <CardChargePeriodicTransfer
                    handlePeriodicityCount={handlePeriodicityCount}
                    handlePeriodicityDate={handlePeriodicityDate}
                    handlePeriodicityEnabled={handlePeriodicityEnabled}
                    handlePeriodicityRange={handlePeriodicityRange}
                    handlePeriodicityType={handlePeriodicityType}
                    handlePeriodicityConcept={handlePeriodicityConcept}
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    setDate={setDate}
                    setTodayDate={setTodayDate}
                />
            );
        }

        return (
            <section className="card-charge-step-one">
                <article className="card-charge-step-one__section">
                    <header className="card-charge-step-one__header">
                        <FormattedText
                            value={title}
                            className="card-charge-step-one__title"
                        />
                    </header>
                    <section className="card-charge-step-one__content">
                        <div className="card-charge-step-one__group">
                            {prepaidBalance}
                        </div>
                        <div className="card-charge-step-one__group">
                            {operationTypes}
                            {cardDischargeOperationError}
                        </div>
                        <div className="card-charge-step-one__group">
                            {accountSelection}
                        </div>
                        <div className="card-charge-step-one__group">
                            <FormattedText
                                className="card-charge-step-one__label"
                                value="cardCharge-amount"
                            />
                            <div className="card-charge-step-one__amount-input">
                                <AmountInput
                                    id="inp_ChargeStep1_Amount"
                                    callback={handleAmountChange}
                                    min={0}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    error={showAmountError}
                                    errorMsg={amountError}
                                    amount={immCardCharge.getIn(['steps', 0, 'amount'])}
                                    disabled={disableInputField}
                                    language={language}
                                    instructionsMessage={instructionsMessage}
                                />
                            </div>
                            <span className="card-charge-step-one__currency">
                                {currency}
                            </span>
                            {withdrawTotalAmountComponent}
                        </div>
                        {periodicTransferFields}
                    </section>
                </article>
            </section>
        );
    }
}

CardChargeStep1.propTypes = {
    accountId: PropTypes.string,
    handleAmountChange: PropTypes.func,
    handleOperationTypeChange: PropTypes.func,
    handlePeriodicityCount: PropTypes.func,
    handlePeriodicityDate: PropTypes.func,
    handlePeriodicityEnabled: PropTypes.func,
    handlePeriodicityRange: PropTypes.func,
    handlePeriodicityType: PropTypes.func,
    handlePeriodicityConcept: PropTypes.func,
    immAccounts: PropTypes.object,
    immCard: PropTypes.object,
    immCardCharge: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    operationType: PropTypes.string,
    oyAccounts: PropTypes.object,
    isPeriodicTransfer: PropTypes.bool,
    withdrawTotalAmount: PropTypes.func,
    setAccount: PropTypes.func,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setDate: PropTypes.func,
    setTodayDate: PropTypes.func,
    view: PropTypes.string,
    moneyRequestDetails: PropTypes.object
};

CardChargeStep1.defaultProps = {
    isLoading: false
};

module.exports.constructor = CardChargeStep1;
module.exports.CardChargeStep1 = connect(null, {
    handleAmountChange: cardChargeActions.setAmount,
    handleOperationTypeChange: cardChargeActions.setOperationType,
    handlePeriodicityCount: cardChargeActions.handlePeriodicityCount,
    handlePeriodicityDate: cardChargeActions.handlePeriodicityDate,
    handlePeriodicityEnabled: cardChargeActions.handlePeriodicityEnabled,
    handlePeriodicityConcept: cardChargeActions.handlePeriodicityConcept,
    handlePeriodicityRange: cardChargeActions.handlePeriodicityRange,
    handlePeriodicityType: cardChargeActions.handlePeriodicityType,
    setAccount: cardChargeActions.setAccount,
    setDate: cardChargeActions.setDate,
    setTodayDate: cardChargeActions.setTodayDate,
    withdrawTotalAmount: cardChargeActions.withdrawTotalAmount
})(CardChargeStep1);
